( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        currencyCode: ( function () {
            return jQuery( 'html' ).data( 'currency' );
        } )(),
        search: {
            result: {
                pages: {
                    show: false
                }
            }
        },
        require: {
            datepicker: {
                url: '//cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js',
                fallback: '/files/templates/designs/UniqueFurniture/_assets/js/vendor/bootstrap-datepicker.js',
                callback: null
            }
        },
        ecom: {
            productListWithFacets: {
                showParamsInUrl: true
            },
        },
        cmdMsg: {
            paramName: 'cmdMsg',
            typeParamName: 'cmdMsgType',
            type: {
                fail: 'danger',
                info: 'info',
                success: 'success',
            }
        },
        offer: {
            url: '/system/data/offer',
            productSearchUrl: '/system/data/offer-product-search',
            pdfLayoutParamName: 'pdfLayout',
            cartCmd: {
                set: 'setcart',
                add: 'createnew',
                setName: 'setname',
                editCart: 'cartupdate',
                copy: 'copy',
                delete: 'emptycart',
                addProduct: 'add',
                deleteAllLines: 'deleteallorderlines',
                deleteLine: 'delorderline',
                updateLine: 'updateorderlines',
                copyLine: 'copyofferline',
                groupLinesByVendor: 'grouplinesbyvendor',
                sortLinesByName: 'sortlinesbyname',
            },
            formAutoPostDelay: 500,
            sortDirection: {
                up: 'up',
                down: 'down',
            },
        },
    } );
}() );